import api from './api';

export interface MedicalDocument {
  id: number;
  patient_id: string;
  case_id?: number | null;
  title: string;
  document_type: string;
  file_url: string;
  file_size?: number | null;
  notes?: string | null;
  uploaded_by?: number | null;
  createdAt: string;
  updatedAt: string;
}

export const getMedicalDocumentsByPatient = async (patientId: string): Promise<MedicalDocument[]> => {
  const response = await api.get(`/medical-documents/patient/${patientId}`);
  return response.data.data;
};

export const getMedicalDocumentsByCase = async (caseId: number): Promise<MedicalDocument[]> => {
  const response = await api.get(`/medical-documents/case/${caseId}`);
  return response.data.data;
};

export const uploadMedicalDocument = async (data: {
  patient_id: string;
  case_id?: number;
  title: string;
  document_type: string;
  notes?: string;
  file: File;
}): Promise<MedicalDocument> => {
  const formData = new FormData();
  formData.append('patient_id', data.patient_id);
  if (data.case_id) formData.append('case_id', String(data.case_id));
  formData.append('title', data.title);
  formData.append('document_type', data.document_type);
  if (data.notes) formData.append('notes', data.notes);
  formData.append('file', data.file);

  const response = await api.post('/medical-documents', formData);
  return response.data.data;
};

export const updateMedicalDocument = async (id: number, data: Partial<{
  title: string;
  document_type: string;
  notes: string;
  case_id: number;
}>): Promise<MedicalDocument> => {
  const response = await api.put(`/medical-documents/${id}`, data);
  return response.data.data;
};

export const deleteMedicalDocument = async (id: number): Promise<void> => {
  await api.delete(`/medical-documents/${id}`);
};

export const viewMedicalDocument = async (id: number): Promise<string> => {
  const response = await api.get(`/medical-documents/${id}/view`);
  const url = response.data?.data?.url || response.data?.url;
  if (!url) {
    throw new Error("Failed to open document");
  }
  return url;
};
